import { RouteObject } from 'react-router-dom';

import { ROUTES } from '@routes/routes.constants';

export const parkingRoutes = [
  {
    path: ROUTES.PARKING_SPACE_RENTING_SUMMARY,
    lazy: async () => ({
      Component: (
        await import('./pages/Summary/ParkingSpaceRentingSummaryPage')
      ).ParkingSpaceRentingSummaryPage,
    }),
  },
  {
    path: ROUTES.PARKING_SPACE_RENTING_FORM,
    lazy: async () => ({
      Component: (
        await import('./pages/ParkingSpaceRentingPage/ParkingSpaceRentingPage')
      ).ParkingSpaceRentingPage,
    }),
  },
  {
    path: ROUTES.PARKING,
    lazy: async () => ({
      Component: (await import('./pages/ParkingFrontPage')).ParkingFrontPage,
    }),
  },
  {
    path: ROUTES.PARKING_LISTING,
    lazy: async () => ({
      Component: (
        await import('./pages/ParkingSpaceListingPage/ParkingSpaceListingPage')
      ).ParkingSpaceListingPage,
    }),
  },
  {
    path: ROUTES.SWITCH_PARKING_SPACES_LISTING,
    lazy: async () => ({
      Component: (
        await import(
          './pages/SwitchParkingSpacesListPage/SwitchParkingSpacesListPage'
        )
      ).SwitchParkingSpacesListPage,
    }),
  },
  {
    path: ROUTES.SWITCH_PARKING_SPACES_FORM,
    lazy: async () => ({
      Component: (
        await import(
          './pages/SwitchParkingSpacesFormPage/SwitchParkingSpacesFormPage'
        )
      ).SwitchParkingSpacesFormPage,
    }),
  },
  {
    path: ROUTES.SWITCH_PARKING_SPACES_SUMMARY,
    lazy: async () => ({
      Component: (
        await import('./pages/Summary/SwitchParkingSpacesSummaryPage')
      ).SwitchParkingSpacesSummaryPage,
    }),
  },
  {
    path: ROUTES.PARKING_TERMINATION,
    lazy: async () => ({
      Component: (
        await import(
          './pages/ParkingSpaceTerminationPage/ParkingSpaceTerminationPage'
        )
      ).ParkingSpaceTerminationPage,
    }),
  },
  {
    path: ROUTES.PARKING_SPACE_RENTING_IDENTIFICATION_CALLBACK_PAGE,
    lazy: async () => ({
      Component: (await import('./pages/ParkingSpaceRentingAutoSubmitPage'))
        .ParkingSpaceRentingAutoSubmitPage,
    }),
  },
  {
    path: ROUTES.SWITCH_PARKING_SPACES_IDENTIFICATION_CALLBACK_PAGE,
    lazy: async () => ({
      Component: (await import('./pages/SwitchParkingSpacesAutoSubmitPage'))
        .SwitchParkingSpacesAutoSubmitPage,
    }),
  },
  {
    path: ROUTES.PARKING_SPACE_CONTRACT_INFO_PAGE,
    lazy: async () => ({
      Component: (await import('./pages/ParkingSpaceContractInfoPage'))
        .ParkingSpaceContractInfoPage,
    }),
  },
] satisfies RouteObject[];
